export default __webpack_public_path__ + "static/media/color-palette.47034a26.svg";